import {ControllerParams} from '@wix/yoshi-flow-editor';

export function getFormattingFunction({
  flowAPI,
  formatingCurrency,
}: {
  flowAPI: ControllerParams['flowAPI'];
  formatingCurrency: string;
}) {
  const createCurrencyFormatter = flowAPI.essentials.createCurrencyFormatterWithDefaults({
    language: getFormattingLanguage(flowAPI),
  });
  const formatCurrency = createCurrencyFormatter();
  return (amount: string | number) => formatCurrency({value: amount, currency: formatingCurrency || 'USD'});
}

function getMLLocale(flowAPI: ControllerParams['flowAPI']) {
  const currentLang = getCurrentlyUsedMultilingualLanguage(flowAPI);
  if (!currentLang) {
    return undefined;
  }
  return currentLang.locale || flowAPI.controllerConfig.wixCodeApi.window.multilingual.currentLanguage;
}

function getFormattingLanguage(flowAPI: ControllerParams['flowAPI']) {
  return getMLLocale(flowAPI) || flowAPI.controllerConfig.wixCodeApi.site.regionalSettings || 'en-US';
}

function getCurrentlyUsedMultilingualLanguage(flowAPI: ControllerParams['flowAPI']) {
  const currentShortLang = flowAPI.controllerConfig.wixCodeApi.window.multilingual.currentLanguage;
  return flowAPI.controllerConfig.wixCodeApi.window.multilingual.siteLanguages.find(
    (lang) => lang.languageCode === currentShortLang
  );
}
